import React from "react";
import ServiceTrackPage from "./ServiceTrackPage";

const agentDevelopmentPhases = [
  {
    step: "01",
    title: "Workflow & Decision Mapping",
    detail:
      "We map workflows, decision paths, and edge cases to define exactly what agents should own end-to-end.",
  },
  {
    step: "02",
    title: "Agent System Design",
    detail:
      "We define tool use, memory boundaries, escalation logic, and guardrails so agent behavior stays reliable.",
  },
  {
    step: "03",
    title: "Build, Evaluate, Integrate",
    detail:
      "We implement agents, connect business systems, and evaluate against quality, latency, and operational KPIs.",
  },
  {
    step: "04",
    title: "Production Rollout",
    detail:
      "We launch with observability, tune in production, and scale proven patterns to additional workflow lanes.",
  },
];

const AgentDevelopmentPage = () => {
  return (
    <ServiceTrackPage
      trackLabel="Agent Development Track"
      title="Agent Development for Enterprise Operations"
      accentLine="Deploy agents that execute with control."
      description="We build production-grade agents for real business workflows. Each agent is designed to act reliably, escalate correctly, and improve with measured feedback loops."
      topPrimaryCtaLabel="Book an Agent Session"
      topSecondaryCtaLabel="See Execution Model"
      engagementId="agent-delivery"
      outcomesHeading="What You Walk Away With"
      outcomes={[
        "Agent scope and task architecture for high-value workflows",
        "Orchestration design for reliable tool-calling and action-taking",
        "Evaluation framework with fallback and escalation paths",
        "Rollout plan with monitoring, ownership, and tuning loops",
      ]}
      metricsHeading="Expected Outcomes"
      metrics={[
        { value: "4-6", label: "weeks to first production agent" },
        { value: "95%+", label: "workflow completion target" },
        { value: "<2%", label: "critical failure threshold" },
        { value: "24/7", label: "agent availability model" },
      ]}
      phases={agentDevelopmentPhases}
      finalEyebrow="Final Step"
      finalTitleLine="Start with one high-impact agent."
      finalAccentLine="Scale with a repeatable operating model."
      finalDescription="Launch where outcomes are visible, then expand using the same architecture, controls, and governance standards."
      finalCtaLabel="Book a Free Audit"
    />
  );
};

export default AgentDevelopmentPage;
